import { Injectable } from '@angular/core';
import { BaseModalService } from 'src/app/shared/services/base-modal/base-modal.service';
import { UserActionDialogConfig } from './user-action-dialog-config.model';

@Injectable({
  providedIn: 'root'
})
export class UserActionDialogModalService extends BaseModalService<UserActionDialogConfig> {}
